module.exports = __webpack_public_path__ + "static/media/915da5ea-56bb-413d-8157-571472a01c77.86387518.JPG";